// src/components/dashboard/CrisisResources.jsx
//
// Canada-correct support lines (data/crisisResources.js) with tappable
// tel:/sms:/web parts. Used as the floor of the Talk-to-Someone modal and on
// worksheet review steps. Topic-specific lines lead, national lines follow.

import React from 'react';
import { Phone, LifeBuoy } from 'lucide-react';
import { resourcesFor, linesForThemes } from '../../data/crisisResources';

// ageTier ('kid' | 'teen' | 'adult') decides whether youth lines show - see
// isYouthMember in data/crisisResources.js. Every caller must pass it.
//   lines  — an explicit list (the modal's "other kinds of support" expander)
//   themes — theme ids from what the member said (utils/crisisDetect.js);
//            the lines for exactly that, youth lines first
const CrisisResources = ({ topicId, memberType, ageTier = null, heading = 'If you need someone right now', compact = false, lines: linesOverride = null, themes = null, showEmergencyNote = true }) => {
    const lines = linesOverride || (themes ? linesForThemes(themes, memberType, ageTier) : resourcesFor(topicId, memberType, ageTier));
    if (lines.length === 0) return null;
    return (
        <div>
            <div className="flex items-center gap-2 mb-2">
                <LifeBuoy size={16} className="text-brand-primary shrink-0" />
                <h4 className="font-black text-slate-900 text-sm">{heading}</h4>
            </div>
            <div className={`space-y-2 ${compact ? '' : 'mt-3'}`}>
                {lines.map(line => (
                    <div key={line.id} className={`rounded-xl border p-3 ${line.urgent ? 'bg-rose-50 border-rose-200' : 'bg-slate-50 border-slate-200'}`}>
                        <div className="flex items-center justify-between gap-2">
                            <p className="text-sm font-black text-slate-900 flex items-center gap-1.5">
                                {line.urgent && <Phone size={14} className="text-rose-600 shrink-0" />}
                                {line.name}
                            </p>
                            {line.region && <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 shrink-0">{line.region}</span>}
                        </div>
                        <p className="text-sm font-bold mt-0.5">
                            {line.parts.map((p, i) => p.href
                                ? <a key={i} href={p.href} target={p.href.startsWith('http') ? '_blank' : undefined} rel={p.href.startsWith('http') ? 'noopener noreferrer' : undefined} className={`underline underline-offset-2 ${line.urgent ? 'text-rose-700' : 'text-brand-primary'}`}>{p.text}</a>
                                : <span key={i} className="text-slate-500 font-medium">{p.text}</span>)}
                        </p>
                        {line.note && <p className="text-xs text-slate-500 font-medium mt-0.5">{line.note}</p>}
                    </div>
                ))}
            </div>
            {showEmergencyNote && <p className="text-[11px] text-slate-400 font-medium mt-2 leading-relaxed">If someone is in immediate danger, call 911.</p>}
        </div>
    );
};

export default CrisisResources;
